import axios from '../axios'


 // 保存
export const save = (data) => {
    return axios({
        url: '/sysTaskType/save',
        method: 'post',
        data
    })
}
 // 列表
export const list = (data) => {
    return axios({
        url: '/sysTaskType/list',
        method: 'post',
        data
    })
}
 // 编辑
 export const edit = (data) => {
    return axios({
        url: '/sysTaskType/edit',
        method: 'post',
        data
    })
}
 // 查看
 export const view = (data) => {
    return axios({
        url: '/sysTaskType/view',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/sysTaskType/delete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sysTaskType.js